/**
 * 配置文件
 */
export default {
    isIndependentApp: false, //是否为单体应用，单体应用模式下仅提供左侧菜单
    systemInfo: {
        key: 'system' //系统key值
    },
    layout: {
        // 布局模式，默认值1
        // 0-经典布局
        // 1-适合内网管理系统的布局
        // 2-适合门户网站的布局
        // 3-与公司原Angular版本相似的布局
        // 4-国光项目定制布局
        layoutType: 4,
        // 默认主题：black、dark-blue、blue、green、d2等等
        // 更多主题值，详见"src/assets/style/theme/list.js"文件中的name值
        defaultTheme: 'd2',//'dark-blue',
        // 面包屑
        isShowBreadcrumb: false,
        // 是否缓存页面数据，即不刷新浏览器的情况下，点击过的页面状态是否保留
        isKeepAlive: false
    },
    menu: {
        // 侧边栏默认折叠状态
        asideCollapse: false,
        // 是否使用模拟菜单，即不加载后台服务提供的动态菜单
        useMockMenu: true
    }

}
